exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* explorer */\n/* actionbar */\n@font-face {\n  font-family: 'cat';\n  src: url(\"/assets/fonts/cat.eot?vcfb5d\");\n  src: url(\"/assets/fonts/cat.eot?vcfb5d#iefix\") format(\"embedded-opentype\"), url(\"/assets/fonts/cat.ttf?vcfb5d\") format(\"truetype\"), url(\"/assets/fonts/cat.woff?vcfb5d\") format(\"woff\"), url(\"/assets/fonts/cat.svg?vcfb5d#cat\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal; }\n\n:host ::ng-deep .wizard {\n  width: 100%;\n  height: 600px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/core/components/resource-wizard/resource-wizard.component.scss
// module id = ../../../../../src/app/modules/core/components/resource-wizard/resource-wizard.component.scss
// module chunks = main